import { io, Socket } from "socket.io-client";
import { parseCookies } from "nookies";
import { SocketEmitEvents, SocketListenEvents } from "types/socket.type";

// TODO: figure out a way to send locale information
export const apiUrl = (process.env.REACT_APP_API_ENDPOINT as string).replace("/api/v1", "");

export const liveClient = io(apiUrl, {
  autoConnect: false,
  transports: ["websocket"],
  auth: (cb) => {
    const accessToken = parseCookies()["QUIX_TOKEN_2"];
    cb({ accessToken });
  }
}) as Socket<SocketListenEvents, SocketEmitEvents>;

const logTag = "[liveClient]";

liveClient.io.on("open", () => {
  console.log(logTag, "Live client connected!");
});

liveClient.io.on("error", (error) => {
  console.error(logTag, "Live client error", error);
});

liveClient.io.on("reconnect", () => {
  console.log(logTag, "Live client reconnected!");
});

liveClient.io.on("reconnect_attempt", (attempt) => {
  console.log(logTag, "Live client reconnected attempt", attempt);
});

liveClient.io.on("reconnect_error", (error) => {
  console.error(logTag, "Live client reconnect error", error);
});

liveClient.io.on("close", () => {
  console.log(logTag, "Live client disconnected");
});
